import { render, staticRenderFns } from "./addProviderHeader.vue?vue&type=template&id=32d1da70&scoped=true"
import script from "./addProviderHeader.vue?vue&type=script&lang=js"
export * from "./addProviderHeader.vue?vue&type=script&lang=js"
import style0 from "./addProviderHeader.vue?vue&type=style&index=0&id=32d1da70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1da70",
  null
  
)

export default component.exports